import {TAppRootState} from 'core/redux/types';
import {Advice} from 'models';
import {selectIsLoading} from 'modules/loader/selectors';
import {productModuleName} from 'modules/product-card/slice';
import {actionSetCurrentProduct} from 'modules/product-card/slice';
import {IProductState} from 'modules/product-card/types';

const select = (state: TAppRootState): IProductState => state[productModuleName];

export const selectIsSelectedSetPrice = (state: TAppRootState): IProductState['isSelectedSetPrice'] =>
    select(state).isSelectedSetPrice;

export const selectProductSetList = (state: TAppRootState): IProductState['productSetList'] =>
    select(state).productSetList;

export const selectProductTotalPrice = (state: TAppRootState): IProductState['productSetTotalPrice'] =>
    select(state).productSetTotalPrice;

export const selectIsCurrentProductLoads = (state: TAppRootState) => {
    return selectIsLoading(actionSetCurrentProduct.type)(state);
};

export const selectProductDeliveryInfo = (state: TAppRootState): IProductState['productDeliveryInfo'] =>
    select(state).productDeliveryInfo;

export const selectProductData = (state: TAppRootState): IProductState['currentProductData'] =>
    select(state).currentProductData;

export const selectProductAdvices = (state: TAppRootState): Advice[] | null | undefined =>
    select(state).currentProductData?.advices;

export const selectImageZoomDirection = (state: TAppRootState): IProductState['imageZoomDirection'] =>
    select(state).imageZoomDirection;
